/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useEffect, useState } from "react";
import { FaDollarSign } from "react-icons/fa";

import { Card, Col, Form, Input, Row, Select, Divider, Button } from "antd";
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import PageHeading from "../../../../../components/common/PageHeading";
import { tenantData } from "./data";

import "./applycredits.css";
import Notes from "../../../../../components/common/Notes";
import AttachmentsUpload from "../../../../../components/common/AttachmentsUpload";
import RightBar from "../../../../../components/common/RightBar";
import RightBarMethod from "../../../../../components/common/RightBar/RightBarMethod";

const ApplyCreditsRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("Charge Late Fees", "1", "", "", "/accounting/receivables_payments/chargelatefees"),
    RightBarMethod("Subsidy Receipts", "2", "", "", ""),
  ]),
  RightBarMethod(
    "Reports",
    "t2",
    <i className="fa-solid fa-chart-column"></i>,
    [
      RightBarMethod("Tenant Ledger", "3", "", "", ""),
      RightBarMethod("Receivables Activity", "4", "", "", ""),
    ]
  ),
  RightBarMethod(
    "HELP TOPICS",
    "t4",
    <i className="fa-solid fa-circle-question"></i>,
    [RightBarMethod("Apply Credits", "5", "", "", "")]
  ),
];

const ApplyCredits = () => {
  const [tenant, setTenant] = useState();
  const [person, setPerson] = useState(null);
  const [amount, setAmount] = useState(0);

  const onChange = (value) => {
    setAmount(0);
    setTenant(value);
    const selectedPerson = tenantData.find((item) => item.value === value);
    setPerson(selectedPerson);
  };

  const [isUnPaid, setIsUnPaid] = useState(false);

  const [inputValues, setInputValues] = useState([]);

  useEffect(() => {
    const newTotal = !isUnPaid
      ? Object.values(inputValues).reduce(
          (total, value) => total - Number(value),
          0
        )
      : Object.values(inputValues).reduce(
          (total, value) => total + Number(value),
          0
        );
    setAmount(newTotal);
  }, [inputValues]);

  const onSearch = (value) => {
    console.log("search:", value);
  };

  const handleAvailableAmount = (e) => {
    setIsUnPaid(false);
    const newValue = Number(e.target.value);
    if (!isNaN(newValue)) {
      setInputValues({ ...inputValues, [e.target.id]: e.target.value });
    }
  };

  const handleUnPaidAmount = (e) => {
    setIsUnPaid(true);
    const newValue = Number(e.target.value);
    if (!isNaN(newValue)) {
      setInputValues({ ...inputValues, [e.target.id]: e.target.value });
    }
  };

  return (
    <div>
      <PageHeading heading="Apply Credits" />
      <Form
        name="basic"
        initialValues={{
          remember: true,
        }}
        autoComplete="off"
        layout="vertical"
      >
        <Card>
          <Row>
            <Col span={8}>
              <Form.Item label="Tenant" name="Tenant" required>
                <Select
                  showSearch
                  allowClear
                  placeholder="Start typing to search"
                  optionFilterProp="children"
                  onChange={onChange}
                  onSearch={onSearch}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    {
                      value:
                        "Alexander Truoccolo - 9723 NE 3rd Pl - 9723 NE 3rd Pl Midwest City, OK 73130",
                      label:
                        "Alexander Truoccolo - 9723 NE 3rd Pl - 9723 NE 3rd Pl Midwest City, OK 73130",
                    },
                    {
                      value:
                        "Aamir Khan (Eagle) - test1 - 912 n creek dr  edmond, OK 73034",
                      label:
                        "Aamir Khan (Eagle) - test1 - 912 n creek dr  edmond, OK 73034",
                    },
                    {
                      value:
                        "Angela S. Lamka-West - 9626 SE 4th - 9626 SE 4th  Midwest City, OK 73130",
                      label:
                        "Angela S. Lamka-West - 9626 SE 4th - 9626 SE 4th  Midwest City, OK 73130",
                    },
                  ]}
                />
              </Form.Item>
              <p>{tenant}</p>
            </Col>
          </Row>
          <Row justify="space-between">
            <Col>
              <h4 style={{ marginTop: "0" }}>
                Available Credits & Prepayments
              </h4>
            </Col>
            <Col>
              <a href="#">Clear Amounts</a>
            </Col>
          </Row>
          <div className="AvailableCreditsAndPrepayments">
            <Row justify="space-between" className="headerOfAvailableCredits">
              <Col span={6}>GL Account</Col>
              <Col span={4}>Date</Col>
              <Col span={6}>Description</Col>
              <Col span={4}>Balance</Col>
              <Col span={4}>Amount To Apply</Col>
            </Row>
            {person?.AvailableCreditsOrPrepayments.length === 0 ? (
              <p style={{ textAlign: "center" }}>
                No Available Credits or Prepayments
              </p>
            ) : (
              ""
            )}
            {person?.AvailableCreditsOrPrepayments.map((item, index) => (
              <Row
                justify="space-between"
                style={{ padding: "6.5px" }}
                key={index}
              >
                <Col span={6}>{item.glAccount}</Col>
                <Col span={4}>{item.date}</Col>
                <Col span={6}>
                  <Input defaultValue={item.description} />
                </Col>
                <Col span={4} style={{ textAlign: "right" }}>
                  {" "}
                  ${item.balance}{" "}
                </Col>
                <Col
                  span={4}
                  style={{ textAlign: "right", paddingLeft: "10px" }}
                >
                  {" "}
                  <Input
                    placeholder="Amount"
                    addonBefore={<FaDollarSign size={12} />}
                    // defaultValue={(Math.round(amount * 100) / 100).toFixed(2)}
                    onChange={handleUnPaidAmount}
                    id={index}
                    value={inputValues.value}
                  />
                </Col>
              </Row>
            ))}
            <Row justify="space-between" style={{ padding: "6.5px" }}>
              <Col span={6}></Col>
              <Col span={4}></Col>
              <Col span={6}></Col>
              <Col span={4} style={{ textAlign: "right", fontWeight: "600" }}>
                Amount to Apply:
              </Col>
              <Col span={4} style={{ textAlign: "right", fontWeight: "600" }}>
                {person?.AvailableCreditsOrPrepayments.length === 0
                  ? "$0.00"
                  : `$ ${(Math.round(amount * 100) / 100).toFixed(2)} `}
              </Col>
            </Row>
          </div>
          <br />
          <Row justify="space-between">
            <Col>
              <h4 style={{ marginTop: "0" }}>Unpaid Charges</h4>
            </Col>
          </Row>
          <div className="AvailableCreditsAndPrepayments">
            <Row justify="space-between" className="headerOfAvailableCredits">
              <Col span={6}>GL Account</Col>
              <Col span={4}>Date</Col>
              <Col span={6}>Description</Col>
              <Col span={4}>Balance</Col>
              <Col span={4}>Amount To Apply</Col>
            </Row>
            {person?.UnpaidCharges.length === 0 ? (
              <p style={{ textAlign: "center" }}>No Unpaid Charges</p>
            ) : (
              ""
            )}
            {person?.UnpaidCharges.map((item, index) => (
              <Row
                justify="space-between"
                style={{ padding: "6.5px" }}
                key={index}
              >
                <Col span={6}>{item.glAccount}</Col>
                <Col span={4}>{item.date}</Col>
                <Col span={6}>
                  <Input defaultValue={item.description} />
                </Col>
                <Col span={4} style={{ textAlign: "right" }}>
                  {" "}
                  ${item.balance}{" "}
                </Col>
                <Col
                  span={4}
                  style={{ textAlign: "right", paddingLeft: "10px" }}
                >
                  <Input
                    placeholder="Amount"
                    addonBefore={<FaDollarSign size={12} />}
                    // defaultValue={(Math.round(amount * 100) / 100).toFixed(2)}
                    onChange={handleAvailableAmount}
                    id={index}
                    value={inputValues.value}
                  />
                </Col>
              </Row>
            ))}
            <Row justify="space-between" style={{ padding: "6.5px" }}>
              <Col span={6}></Col>
              <Col span={4}></Col>
              <Col span={6}></Col>
              <Col span={4} style={{ textAlign: "right", fontWeight: "600" }}>
                Amount to Apply:
              </Col>
              <Col span={4} style={{ textAlign: "right", fontWeight: "600" }}>
                {person?.UnpaidCharges.length === 0
                  ? "$0.00"
                  : `$ ${(Math.round(amount * 100) / 100).toFixed(2)} `}
              </Col>
            </Row>
            <Divider />
            <Row justify="end">
              <Col span={4} style={{ textAlign: "right", fontWeight: "400" }}>
                Amount Remaining:
              </Col>
              <Col span={4} style={{ textAlign: "right", fontWeight: "400" }}>
                {amount === 0 ? (
                  <CheckCircleOutlined style={{ color: "green" }} />
                ) : (
                  <ExclamationCircleOutlined style={{ color: "red" }} />
                )}{" "}
                ${(Math.round(amount * 100) / 100).toFixed(2)}
              </Col>
            </Row>
          </div>
        </Card>
        <br />
        <Row gutter={16}>
          <Col>
            <Button type="primary">Save & Add Another</Button>
          </Col>
          <Col>
            <Button>Save</Button>
          </Col>
          <Col>
            <Button type="link">Cancel</Button>
          </Col>
        </Row>
        <br />
        <Row gutter={[0, 24]}>
          <Col span={24}>
            {/* <Notes /> */}
          </Col>
          <Col span={24}>
            {/* <AttachmentsUpload /> */}
          </Col>
        </Row>
      </Form>
      <div className="RightSidebar">
        <RightBar RightBarData={ApplyCreditsRightBar} />
      </div>
    </div>
  );
};

export default ApplyCredits;
